import React, {useState} from "react";
import axios from "axios";
import {Link, List, ListItem, Box, Button, Typography} from '@mui/material/';
import TextInput from "../components/TextInput";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";


const PhoneVerify = () => {
    const [error, setError] = useState('')
    const [message, setMessage] = useState('')
    let data = (JSON.parse(localStorage.getItem('phoneAndName')))
    if (message === '') {
        setMessage("A verification code was sent to " + data.phone)
    }

    const resendVerification = () => {
        axios.post(constants.serverURL + "submitPhoneAndName", data,
            {
                withCredentials: true
            }).then(response => {
            window.location.href = constants.websiteURL + '#/phoneverify'
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=phone'
            } else {
                setError(error.request.responseText)
            }
        })

    }

    const submitData = (code) => {
        data.code = code.code
        axios.post(constants.serverURL + "verifyPhone", data,
            {
                withCredentials: true
            }).then(response => {
                if (response.data === 'mentor') {
                    window.location.href = constants.websiteURL + '#/mentorform'
                } else {
                    window.location.href = constants.websiteURL + '#/menteeform'
                }
        }).catch((error) => {
            if (error.request.responseText === 'expired token') {
                window.location.href = constants.websiteURL + '#/refreshToken?redirect=phoneVerify'
            } else {
                setMessage(false)
                setError(error.request.responseText)
            }
        })

    }
    const validationSchema = Yup.object().shape({
        code: Yup.string().required('(This field is required)')
    })
    const { control, handleSubmit, formState: { errors }, setValue} = useForm({ resolver: yupResolver(validationSchema), shouldFocusError: true});


    return (
        <div>
            <MenuAppBar title="" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                    <List>
                        {
                            message &&
                            <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                                <Typography className="font-16">{message}</Typography>
                            </ListItem>
                        }
                        {
                            error &&
                            <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                                <Typography className="font-16 error-message">{error}</Typography>
                            </ListItem>
                        }
                        <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                            <TextInput
                                name={"code"}
                                control={control}
                                question={"Verification Code"}
                                required={true}
                                errors={errors.code}
                            />
                        </ListItem>
                        <Link component="button" onClick={resendVerification}>Resend verification code</Link>
                        <br></br>
                        <br></br>
                        <Button type='submit' className="m-form-button" variant="outlined" onClick={handleSubmit(submitData)}>Submit</Button>

                    </List>
                </Box>
            </form>
        </div>
    );
};

export default PhoneVerify;